import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { EditableInfoComponent } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { CompetitorPricingIcon, MarginRangeIcon, MarkupIcon, PhoneIcon } from 'components/common/icons';
import { Button, Col, Row, Typography } from 'antd';
import { EditPricing } from 'feature/brandTabs/pricingAndSuppliers/pricing/edit';
import { usePricing } from 'feature/brandTabs/pricingAndSuppliers/pricing/usePricing';
import { WebsitePricingCard } from 'feature/brandTabs/pricingAndSuppliers/pricing/WebsitePricingCard';
import styles from './../styles.module.scss';
import { AllWebsiteDrawer } from 'feature/brandTabs/pricingAndSuppliers/pricing/allWebsiteDrawer';

const { Text } = Typography;

export const Pricing = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { updateModalState, onUpdateModalStateChange, dataToEdit, onExpand, drawerState } = usePricing();
  return (
    <>
      <EditableInfoComponent
        title={'Pricing Rules'}
        editable={hasAccess(PERMISSIONS.brands.pricing_rules.write)}
        icon={<PhoneIcon />}
        onEdite={onUpdateModalStateChange}
      />
      <Row gutter={[0, 4]}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row align={'middle'} gutter={[4, 0]}>
                <MarkupIcon />
                <Col>
                  <Text type={'secondary'}>Margin</Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {dataToEdit.markup !== null && dataToEdit.markup !== undefined ? `${dataToEdit.markup}%` : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row align={'middle'} gutter={[4, 0]}>
                <MarginRangeIcon />
                <Col>
                  <Text type={'secondary'}>Margin Range</Text>
                </Col>
              </Row>
            </Col>
            <Col>
              <Text type={'secondary'}>
                {dataToEdit.minMargin !== null &&
                dataToEdit.minMargin !== undefined &&
                dataToEdit.maxMargin !== null &&
                dataToEdit.maxMargin !== undefined
                  ? `${dataToEdit.minMargin}-${dataToEdit.maxMargin}%`
                  : dataToEdit.minMargin !== null && dataToEdit.minMargin !== undefined
                    ? `${dataToEdit.minMargin} Min`
                    : dataToEdit.maxMargin !== null && dataToEdit.maxMargin !== undefined
                      ? `${dataToEdit.maxMargin} Max`
                      : 'Not Set'}
              </Text>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'}>
            <Col>
              <Row align={'middle'} gutter={[4, 0]}>
                <CompetitorPricingIcon />
                <Col>
                  <Text type={'secondary'}>Competitor Pricing</Text>
                </Col>
              </Row>
            </Col>
            <Col>{!dataToEdit.websites?.length && <Text type={'secondary'}>Not Set</Text>}</Col>
          </Row>
          {!!dataToEdit.websites?.length && (
            <Col>
              <Row gutter={[6, 6]} className={'margin-t-12'}>
                {dataToEdit.websites
                  ?.filter((_: any, i: number) => i < 9)
                  .map((_website: any, i: number) => (
                    <Col span={8} key={i}>
                      <WebsitePricingCard website={_website} />
                    </Col>
                  ))}
              </Row>
              {dataToEdit.websites?.length > 9 && (
                <Row justify={'end'}>
                  <Button type={'link'} size={'small'} className={styles.see_all} onClick={onExpand}>
                    See All
                  </Button>
                </Row>
              )}
            </Col>
          )}
        </Col>
      </Row>
      <EditPricing
        modalState={updateModalState}
        onModalStateChange={onUpdateModalStateChange}
        dataToEdit={dataToEdit}
      />
      <AllWebsiteDrawer drawerState={drawerState} onExpand={onExpand} data={dataToEdit.websites} />
    </>
  );
});
